export const getUserId = ( { sidebarReducer: { userData } } ) => userData.id;
